export const OPEN_CHAT = 'OPEN_CHAT'
export const CLOSE_CHAT = 'CLOSE_CHAT'
export const MAXIMIZE_CHAT = 'MAXIMIZE_CHAT'
export const MINIMIZE_CHAT = 'MINIMIZE_CHAT'
export const START_CONVERSATION = 'START_CONVERSATION'
export const CLOSE_CONVERSATION = 'CLOSE_CONVERSATION'
export const STARTED_CONVERSATION = 'STARTED_CONVERSATION'
export const CLOSED_CONVERSATION = 'CLOSED_CONVERSATION'
export const ACCEPT_DATA_PROCESSING_CONSENT_DIALOG =
  'ACCEPT_DATA_PROCESSING_CONSENT_DIALOG'

export const OPEN_ROBOT = 'OPEN_ROBOT'
export const CLOSE_ROBOT = 'CLOSE_ROBOT'

export const SET_USER_INPUT_TEXT = 'SET_USER_INPUT'

export const SET_LOCALE = 'SET_LANGUAGE'
export const SET_EDIT_MESSAGE = 'SET_EDIT_MESSAGE'

export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'

export const TOGGLE_SHOW_SYSTEM_MESSAGES = 'TOGGLE_DEBUG'

export const ADD_MESSAGE = 'ADD_MESSAGE'
export const ADD_MESSAGES = 'ADD_MESSAGES'
export const ADD_SOCKET_MESSAGE = 'ADD_SOCKET_MESSAGE'

export const SOCKET_EMIT_NEW_USER_MESSAGE = 'SOCKET_EMIT_NEW_USER_MESSAGE'
export const SOCKET_ON_CONNECT = 'SOCKET_ON_CONNECT'
export const SOCKET_ON_SESSION_CONFIRM = 'SOCKET_ON_SESSION_CONFIRM'
export const SOCKET_ON_LANGUAGE_CHANGE = 'SOCKET_ON_LANGUAGE_CHANGE'
export const SOCKET_ON_CONNECT_ERROR = 'SOCKET_ON_CONNECT_ERROR'
export const SOCKET_ON_RECONNECT_ATTEMPTS = 'SOCKET_ON_RECONNECT_ATTEMPTS'
export const SOCKET_ON_ERROR = 'SOCKET_ON_ERROR'
export const SOCKET_ON_DISCONNECT = 'SOCKET_ON_DISCONNECT'
export const SOCKET_ON_MESSAGE = 'SOCKET_ON_MESSAGE'
export const SOCKET_ON_REPLACE_LAST_MESSAGE = 'SOCKET_ON_REPLACE_LAST_MESSAGE'
export const SOCKET_ON_JOIN_CONFIRM = 'SOCKET_ON_JOIN_CONFIRM'
export const SOCKET_ON_LEAVE_CONFIRM = 'SOCKET_ON_LEAVE_CONFIRM'
export const SOCKET_ON_OPERATOR_TYPING = 'SOCKET_ON_OPERATOR_TYPING'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'

export const IS_RESTRICTED = 'IS_RESTRICTED'

export const ENABLE_CHAT_BOT = 'ENABLE_CHAT_BOT'
export const EMIT_REGENERATE_MESSAGE = 'EMIT_REGENERATE_MESSAGE'
export const ENABLE_LIVE_CHAT = 'ENABLE_LIVE_CHAT'
export const ENABLE_INPUT_FIELD = 'ENABLE_INPUT_FIELD'

export const SMART_DOC = 'SMART_DOC'
export const SET_COPILOT_THEME = 'SET_COPILOT_THEME'

export const SET_BACK_DISABLED = 'SET_BACK_DISABLED'
export const SET_BACK_INPUT_DISABLED = 'SET_BACK_INPUT_DISABLED'
export const SET_INPUT_ENABLED = 'SET_INPUT_ENABLED'
export const SET_CONFIG = 'SET_CONFIG'
export const SET_DOCUMENT_VIEW_CONFIG = 'SET_DOCUMENT_VIEW_CONFIG'
export const SET_COPILOT_AI_CONFIG = 'SET_COPILOT_AI_CONFIG'
export const SET_DOCUMENT_REFERENCES = 'SET_DOCUMENT_REFERENCES'
export const SET_COPILOT_CHAT = 'SET_COPILOT_CHAT'
export const IS_MESSAGE_LIMIT_REACHED = 'IS_MESSAGE_LIMIT_REACHED'
export const SET_CURRENT_DOCUMENT_ID = 'SET_CURRENT_DOCUMENT_ID'
export const SET_THEME = 'SET_THEME'
export const SET_FILE_UPLOAD_ENABLED = 'SET_FILE_UPLOAD_ENABLED'
export const SHOW_PROACTIVE_MESSAGE = 'SHOW_PROACTIVE_MESSAGE'
export const SET_POST_MESSAGE_TARGET = 'SET_POST_MESSAGE_TARGET'
export const SET_CONVERSATION_PDF_REQUESTED = 'SET_CONVERSATION_PDF_REQUESTED'
export const SET_PDF_DOWNLOAD_ENABLED = 'SET_PDF_DOWNLOAD_ENABLED'
export const SET_PARENT_WINDOW_SIZE = 'SET_PARENT_WINDOW_SIZE'
export const SET_SUGGESTIONS_ENABLED = 'SET_SUGGESTIONS_ENABLED'
export const SET_AI_AGENT_CHAT = 'SET_AI_AGENT_CHAT'

export const SET_LAST_SMARTDOC_SEGMENT_TOOLTIPS =
  'SET_LAST_SMARTDOC_SEGMENT_TOOLTIPS'

export const UNLEASH_INIT = 'UNLEASH_INIT'

export const SET_SEMANTIC_SUGGESTIONS_ENABLED =
  'SET_SEMANTIC_SUGGESTIONS_ENABLED'

export const SET_NEXTGEN = 'SET_NEXTGEN'
export const SET_PROMPTS = 'SET_PROMPTS'
export const SET_PROMPT_FOLDERS = 'SET_PROMPT_FOLDERS'

export const SET_HIDE_INITIAL_TYPING_INDICATOR = 'SET_HIDE_INITIAL_TYPING_INDICATOR'
export const SET_READ_ONLY_MODE = 'SET_READ_ONLY_MODE'

export const SOCKET_ON_DOCUMENT_INDEXED = 'SOCKET_ON_DOCUMENT_INDEXED'
export const REMOVE_DOCUMENT_INDEXED_EVENT = 'REMOVE_DOCUMENT_INDEXED_EVENT'

/** Web search tool progress (Socket.IO); null = hidden */
export const SOCKET_ON_WEB_SEARCH_PROGRESS = 'SOCKET_ON_WEB_SEARCH_PROGRESS'

export const SET_ANALYTICS_CONTEXT = 'SET_ANALYTICS_CONTEXT'